import { JsonpClientBackend } from '@angular/common/http';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AdminCtrlVehGeocerca } from 'src/app/models/admin-ctrlvehiculo-geocerca';
import { ControlVehiculosService } from 'src/app/services/admin/control-vehiculos-service/control-vehiculos.service';
import { ControlGeocercaService } from 'src/app/services/flota/control-geocerca-service/control-geocerca.service';
import { ConfirmDialog } from 'src/app/shared/confirmdialog/confirmdialog.component';
import { Gtp } from 'src/app/shared/gtp';

@Component({
  selector: 'app-control-vehiculos-geocerca',
  templateUrl: './control-vehiculos-geocerca.component.html',
  styleUrls: ['./control-vehiculos-geocerca.component.scss']
})
export class ControlVehiculosGeocerca implements OnInit, OnDestroy {    
  
  loading:boolean = false;
  public contClass: string = 'container-fluid maincont';
  public params = {
    latitud: null,
    longitud: null,
    descripcion: null,
    geocerca: null,
  };

  fechalang: any;

  //Listado de Geocercas
  public geocercas = [];
  public geocercasFiltered = [];
  //Geocercas en perfil
  public geoEnPerfil = [];
  
  public intervaloNotif = null;
  
  public rangohoras = {
    lunes: {
      desde: {
        primero: null,
        segundo: null
      },
      hasta: {
        primero: null,
        segundo: null
      },
    },
    martes: {
      desde: {
        primero: null,
        segundo: null
      },
      hasta: {
        primero: null,
        segundo: null
      },
    },
    miercoles: {
      desde: {
        primero: null,
        segundo: null
      },
      hasta: {
        primero: null,
        segundo: null
      },
    },
    jueves: {
      desde: {
        primero: null,
        segundo: null
      },
      hasta: {
        primero: null,
        segundo: null
      },
    },
    viernes: {
      desde: {
        primero: null,
        segundo: null
      },
      hasta: {
        primero: null,
        segundo: null
      },
    },
    sabado: {
      desde: {
        primero: null,
        segundo: null
      },
      hasta: {
        primero: null,
        segundo: null
      },
    },
    domingo: {
      desde: {
        primero: null,
        segundo: null
      },
      hasta: {
        primero: null,
        segundo: null
      },
    },
  };

  public perfilData = {
    geocercas: null,
    rangohoras: null,
    intervalonotif: null
  };

  public saveInterval;
  public defaultDate: Date;

  constructor(
    public gtp: Gtp,
    private dialog: MatDialog,
    private ctrlGeocercaService: ControlGeocercaService,
    private ctrlVehiculo: ControlVehiculosService,
  ) {
    this.fechalang = this.gtp.fechalang;    
    this.defaultDate = this.gtp.setHoras(0, 0, 0);
    this.ctrlGeocercaService.getListaGeocercas().subscribe(res => {
      this.geocercas = res['rows'];
      this.geocercasFiltered = res['rows'];
    });        
  }
  
  ngOnInit(): void {    
    if (this.ctrlVehiculo.geocercaConfig.geocercas) {
      if (this.ctrlVehiculo.geocercaConfig.geocercas.length>0) {
        this.setInitialInfo();
      }
    }
  }

  ngOnDestroy():void{
    //if (this.saveInterval){ this.saveInterval.unsubscribe(); }
  }

  setInitialInfo(){    
    //Set Intervalo Notificaciones
    this.intervaloNotif = this.ctrlVehiculo.geocercaConfig.intervalonotif;
    //Set Rango de Horas
    this.rangohoras.lunes.desde.primero = this.formatRango(this.ctrlVehiculo.geocercaConfig.rangohoras.lunes.desde.primero);
    this.rangohoras.lunes.hasta.primero = this.formatRango(this.ctrlVehiculo.geocercaConfig.rangohoras.lunes.hasta.primero);
    this.rangohoras.martes.desde.primero = this.formatRango(this.ctrlVehiculo.geocercaConfig.rangohoras.martes.desde.primero);
    this.rangohoras.martes.hasta.primero = this.formatRango(this.ctrlVehiculo.geocercaConfig.rangohoras.martes.hasta.primero);
    this.rangohoras.miercoles.desde.primero = this.formatRango(this.ctrlVehiculo.geocercaConfig.rangohoras.miercoles.desde.primero);
    this.rangohoras.miercoles.hasta.primero = this.formatRango(this.ctrlVehiculo.geocercaConfig.rangohoras.miercoles.hasta.primero);
    this.rangohoras.jueves.desde.primero = this.formatRango(this.ctrlVehiculo.geocercaConfig.rangohoras.jueves.desde.primero);
    this.rangohoras.jueves.hasta.primero = this.formatRango(this.ctrlVehiculo.geocercaConfig.rangohoras.jueves.hasta.primero);
    this.rangohoras.viernes.desde.primero = this.formatRango(this.ctrlVehiculo.geocercaConfig.rangohoras.viernes.desde.primero);
    this.rangohoras.viernes.hasta.primero = this.formatRango(this.ctrlVehiculo.geocercaConfig.rangohoras.viernes.hasta.primero);
    this.rangohoras.sabado.desde.primero = this.formatRango(this.ctrlVehiculo.geocercaConfig.rangohoras.sabado.desde.primero);
    this.rangohoras.sabado.hasta.primero = this.formatRango(this.ctrlVehiculo.geocercaConfig.rangohoras.sabado.hasta.primero);
    this.rangohoras.domingo.desde.primero = this.formatRango(this.ctrlVehiculo.geocercaConfig.rangohoras.domingo.desde.primero);
    this.rangohoras.domingo.hasta.primero = this.formatRango(this.ctrlVehiculo.geocercaConfig.rangohoras.domingo.hasta.primero);    
    this.rangohoras.lunes.desde.segundo = this.formatRango(this.ctrlVehiculo.geocercaConfig.rangohoras.lunes.desde.segundo);
    this.rangohoras.lunes.hasta.segundo = this.formatRango(this.ctrlVehiculo.geocercaConfig.rangohoras.lunes.hasta.segundo);
    this.rangohoras.martes.desde.segundo = this.formatRango(this.ctrlVehiculo.geocercaConfig.rangohoras.martes.desde.segundo);
    this.rangohoras.martes.hasta.segundo = this.formatRango(this.ctrlVehiculo.geocercaConfig.rangohoras.martes.hasta.segundo);
    this.rangohoras.miercoles.desde.segundo = this.formatRango(this.ctrlVehiculo.geocercaConfig.rangohoras.miercoles.desde.segundo);
    this.rangohoras.miercoles.hasta.segundo = this.formatRango(this.ctrlVehiculo.geocercaConfig.rangohoras.miercoles.hasta.segundo);
    this.rangohoras.jueves.desde.segundo = this.formatRango(this.ctrlVehiculo.geocercaConfig.rangohoras.jueves.desde.segundo);
    this.rangohoras.jueves.hasta.segundo = this.formatRango(this.ctrlVehiculo.geocercaConfig.rangohoras.jueves.hasta.segundo);
    this.rangohoras.viernes.desde.segundo = this.formatRango(this.ctrlVehiculo.geocercaConfig.rangohoras.viernes.desde.segundo);
    this.rangohoras.viernes.hasta.segundo = this.formatRango(this.ctrlVehiculo.geocercaConfig.rangohoras.viernes.hasta.segundo);
    this.rangohoras.sabado.desde.segundo = this.formatRango(this.ctrlVehiculo.geocercaConfig.rangohoras.sabado.desde.segundo);
    this.rangohoras.sabado.hasta.segundo = this.formatRango(this.ctrlVehiculo.geocercaConfig.rangohoras.sabado.hasta.segundo);
    this.rangohoras.domingo.desde.segundo = this.formatRango(this.ctrlVehiculo.geocercaConfig.rangohoras.domingo.desde.segundo);
    this.rangohoras.domingo.hasta.segundo = this.formatRango(this.ctrlVehiculo.geocercaConfig.rangohoras.domingo.hasta.segundo);
    this.geoEnPerfil = this.ctrlVehiculo.geocercaConfig.geocercas;
  }

  formatRango(hora){
    let dia = this.gtp.getDay(new Date()).split('/');
    let fecha = `${dia[2]}/${dia[1]}/${dia[0]} ${hora}`;
    return this.gtp.String2Date(fecha);
  }

  horario_notificacion(){
    this.intervaloNotif = this.gtp.setHoras(0, 0, 0);
    this.rangohoras.lunes.desde.primero = this.gtp.setHoras(0, 0, 0);
    this.rangohoras.lunes.hasta.primero = this.gtp.setHoras(0, 0, 0);
    this.rangohoras.martes.desde.primero = this.gtp.setHoras(0, 0, 0);
    this.rangohoras.martes.hasta.primero = this.gtp.setHoras(0, 0, 0);
    this.rangohoras.miercoles.desde.primero = this.gtp.setHoras(0, 0, 0);
    this.rangohoras.miercoles.hasta.primero = this.gtp.setHoras(0, 0, 0);
    this.rangohoras.jueves.desde.primero = this.gtp.setHoras(0, 0, 0);
    this.rangohoras.jueves.hasta.primero = this.gtp.setHoras(0, 0, 0);
    this.rangohoras.viernes.desde.primero = this.gtp.setHoras(0, 0, 0);
    this.rangohoras.viernes.hasta.primero = this.gtp.setHoras(0, 0, 0);
    this.rangohoras.sabado.desde.primero = this.gtp.setHoras(0, 0, 0);
    this.rangohoras.sabado.hasta.primero = this.gtp.setHoras(0, 0, 0);
    this.rangohoras.domingo.desde.primero = this.gtp.setHoras(0, 0, 0);
    this.rangohoras.domingo.hasta.primero = this.gtp.setHoras(0, 0, 0);
    
    this.rangohoras.lunes.desde.segundo = this.gtp.setHoras(0, 0, 0);
    this.rangohoras.lunes.hasta.segundo = this.gtp.setHoras(0, 0, 0);
    this.rangohoras.martes.desde.segundo = this.gtp.setHoras(0, 0, 0);
    this.rangohoras.martes.hasta.segundo = this.gtp.setHoras(0, 0, 0);
    this.rangohoras.miercoles.desde.segundo = this.gtp.setHoras(0, 0, 0);
    this.rangohoras.miercoles.hasta.segundo = this.gtp.setHoras(0, 0, 0);
    this.rangohoras.jueves.desde.segundo = this.gtp.setHoras(0, 0, 0);
    this.rangohoras.jueves.hasta.segundo = this.gtp.setHoras(0, 0, 0);
    this.rangohoras.viernes.desde.segundo = this.gtp.setHoras(0, 0, 0);
    this.rangohoras.viernes.hasta.segundo = this.gtp.setHoras(0, 0, 0);
    this.rangohoras.sabado.desde.segundo = this.gtp.setHoras(0, 0, 0);
    this.rangohoras.sabado.hasta.segundo = this.gtp.setHoras(0, 0, 0);
    this.rangohoras.domingo.desde.segundo = this.gtp.setHoras(0, 0, 0);
    this.rangohoras.domingo.hasta.segundo = this.gtp.setHoras(0, 0, 0);    
  }

  /**
   * Cierra la ventana del informe activa.
   */
  cerrarInforme() {
    this.gtp.cerrarVentanas(true);
  }

  /**
   * Aumenta o disminuye el tamaño del ancho en el informe.
   */
  containerSize() {
    this.contClass = this.gtp.containerSize(this.contClass);
  }

  filterGeocerca(query) {
    let res = this.geocercas.filter(s => (s.descripcion.toLocaleLowerCase().includes(query.toLocaleLowerCase())));
    this.geocercasFiltered = (query == '') ? this.geocercas : res;
  }

  addGeocerca(geo) {
    geo = new AdminCtrlVehGeocerca(geo);
    let res = this.geoEnPerfil.filter(s => (s.geoid == geo.geoid));    
    if (res.length==0) { this.geoEnPerfil.push(geo); }    
  }
  
  removeGeo(id, pos){
    const dialogRef = this.dialog.open(ConfirmDialog, {
      width: this.gtp.confirmMinWidh,
      data: {
        value: id,
        titulo: 'BORRAR GEOCERCA',
        descr: '¿Está seguro que querer eliminar el registro?',
        success_class: 'danger',
        success_text: 'Eliminar'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.geoEnPerfil.splice(pos, 1);
      }
    });    
  }


  parseRangoHoras(){
    const rangohoras = {
      lunes: {
        desde: {
          primero: (this.gtp.validDate(this.rangohoras.lunes.desde.primero)) ? this.gtp.getHourMinuteSecond(this.rangohoras.lunes.desde.primero) : null,
          segundo: (this.gtp.validDate(this.rangohoras.lunes.desde.segundo)) ? this.gtp.getHourMinuteSecond(this.rangohoras.lunes.desde.segundo) : null,
        },
        hasta: {
          primero: (this.gtp.validDate(this.rangohoras.lunes.hasta.primero)) ? this.gtp.getHourMinuteSecond(this.rangohoras.lunes.hasta.primero) : null,
          segundo: (this.gtp.validDate(this.rangohoras.lunes.hasta.segundo)) ? this.gtp.getHourMinuteSecond(this.rangohoras.lunes.hasta.segundo) : null,
        }
      },
      martes: {
        desde: {
          primero: (this.gtp.validDate(this.rangohoras.martes.desde.primero)) ? this.gtp.getHourMinuteSecond(this.rangohoras.martes.desde.primero) : null,
          segundo: (this.gtp.validDate(this.rangohoras.martes.desde.segundo)) ? this.gtp.getHourMinuteSecond(this.rangohoras.martes.desde.segundo) : null,
        },
        hasta: {
          primero: (this.gtp.validDate(this.rangohoras.martes.hasta.primero)) ? this.gtp.getHourMinuteSecond(this.rangohoras.martes.hasta.primero) : null,
          segundo: (this.gtp.validDate(this.rangohoras.martes.hasta.segundo)) ? this.gtp.getHourMinuteSecond(this.rangohoras.martes.hasta.segundo) : null,
        }
      },
      miercoles: {
        desde: {
          primero: (this.gtp.validDate(this.rangohoras.miercoles.desde.primero)) ? this.gtp.getHourMinuteSecond(this.rangohoras.miercoles.desde.primero) : null,
          segundo: (this.gtp.validDate(this.rangohoras.miercoles.desde.segundo)) ? this.gtp.getHourMinuteSecond(this.rangohoras.miercoles.desde.segundo) : null,
        },
        hasta: {
          primero: (this.gtp.validDate(this.rangohoras.miercoles.hasta.primero)) ? this.gtp.getHourMinuteSecond(this.rangohoras.miercoles.hasta.primero) : null,
          segundo: (this.gtp.validDate(this.rangohoras.miercoles.hasta.segundo)) ? this.gtp.getHourMinuteSecond(this.rangohoras.miercoles.hasta.segundo) : null,
        }
      },
      jueves: {
        desde: {
          primero: (this.gtp.validDate(this.rangohoras.jueves.desde.primero)) ? this.gtp.getHourMinuteSecond(this.rangohoras.jueves.desde.primero) : null,
          segundo: (this.gtp.validDate(this.rangohoras.jueves.desde.segundo)) ? this.gtp.getHourMinuteSecond(this.rangohoras.jueves.desde.segundo) : null,
        },
        hasta: {
          primero: (this.gtp.validDate(this.rangohoras.jueves.hasta.primero)) ? this.gtp.getHourMinuteSecond(this.rangohoras.jueves.hasta.primero) : null,
          segundo: (this.gtp.validDate(this.rangohoras.jueves.hasta.segundo)) ? this.gtp.getHourMinuteSecond(this.rangohoras.jueves.hasta.segundo) : null,
        }
      },
      viernes: {
        desde: {
          primero: (this.gtp.validDate(this.rangohoras.viernes.desde.primero)) ? this.gtp.getHourMinuteSecond(this.rangohoras.viernes.desde.primero) : null,
          segundo: (this.gtp.validDate(this.rangohoras.viernes.desde.segundo)) ? this.gtp.getHourMinuteSecond(this.rangohoras.viernes.desde.segundo) : null,
        },
        hasta: {
          primero: (this.gtp.validDate(this.rangohoras.viernes.hasta.primero)) ? this.gtp.getHourMinuteSecond(this.rangohoras.viernes.hasta.primero) : null,
          segundo: (this.gtp.validDate(this.rangohoras.viernes.hasta.segundo)) ? this.gtp.getHourMinuteSecond(this.rangohoras.viernes.hasta.segundo) : null,
        }
      },
      sabado: {
        desde: {
          primero: (this.gtp.validDate(this.rangohoras.sabado.desde.primero)) ? this.gtp.getHourMinuteSecond(this.rangohoras.sabado.desde.primero) : null,
          segundo: (this.gtp.validDate(this.rangohoras.sabado.desde.segundo)) ? this.gtp.getHourMinuteSecond(this.rangohoras.sabado.desde.segundo) : null,
        },
        hasta: {
          primero: (this.gtp.validDate(this.rangohoras.sabado.hasta.primero)) ? this.gtp.getHourMinuteSecond(this.rangohoras.sabado.hasta.primero) : null,
          segundo: (this.gtp.validDate(this.rangohoras.sabado.hasta.segundo)) ? this.gtp.getHourMinuteSecond(this.rangohoras.sabado.hasta.segundo) : null,
        }
      },
      domingo: {
        desde: {
          primero: (this.gtp.validDate(this.rangohoras.domingo.desde.primero)) ? this.gtp.getHourMinuteSecond(this.rangohoras.domingo.desde.primero) : null,
          segundo: (this.gtp.validDate(this.rangohoras.domingo.desde.segundo)) ? this.gtp.getHourMinuteSecond(this.rangohoras.domingo.desde.segundo) : null,
        },
        hasta: {
          primero: (this.gtp.validDate(this.rangohoras.domingo.hasta.primero)) ? this.gtp.getHourMinuteSecond(this.rangohoras.domingo.hasta.primero) : null,
          segundo:(this.gtp.validDate(this.rangohoras.domingo.hasta.segundo)) ? this.gtp.getHourMinuteSecond(this.rangohoras.domingo.hasta.segundo) : null,
        }
      }
    };
    return rangohoras;
  }

  parseGeocercas(){
    var geo = [];    
    this.geoEnPerfil.forEach(el => {
      console.log( el );
      //el.maxparada = this.gtp.getHourMinuteSecondxparada);
      el.maxparada = el.maxparada;
      geo.push(el);
    });
    return geo;
  }

  saveParams(){    
    
    this.perfilData = {
      //geocercas: this.geoEnPerfil,
      geocercas: this.parseGeocercas(),
      rangohoras: this.parseRangoHoras(),
      intervalonotif: this.intervaloNotif,
    };

    this.perfilData = JSON.parse(JSON.stringify(this.perfilData));    
    this.ctrlVehiculo.setGeocercaConfig(this.perfilData);    
    console.log('Actualizando...');

  }

}
